import React from 'react'
import LineSeparator from '../../../../../packages/kiti/components/helpers/LineSeparator'
import { COLORS } from '@btime/constants'
import Separator from '../../../../../components/pdf/Separator'
import { findReplyByQuestionId } from '../../_helpers/pdfHelpers'
import { useServiceOrder } from '../../_load/ServiceOrderLoader'
import { Col, Grid } from '../../../../../packages/kiti/components/structure/Grid'
import Image from '../../../../../components/pdf/Image'
import View from '../../../../../components/pdf/View'
import { MONTHS } from '../../constants/dates'
import { BODY_ORIGIN_ID, useEasySolutionsPageNumbers } from '../../_shared/pagination'

const Content = () => {
  const { replies, endDate } = useServiceOrder()
  const question302 = findReplyByQuestionId(replies, 302)
  const question303 = findReplyByQuestionId(replies, 303)
  const question304 = findReplyByQuestionId(replies, 304)
  const question311 = findReplyByQuestionId(replies, 311)
  const question312 = findReplyByQuestionId(replies, 312)
  const question342 = findReplyByQuestionId(replies, 342)
  const question315 = findReplyByQuestionId(replies, 315)
  const question316 = findReplyByQuestionId(replies, 316)
  const question318 = findReplyByQuestionId(replies, 318)
  const question319 = findReplyByQuestionId(replies, 319)
  const question320 = findReplyByQuestionId(replies, 320)
  const question321 = findReplyByQuestionId(replies, 321)
  const question322 = findReplyByQuestionId(replies, 322)
  const question323 = findReplyByQuestionId(replies, 323)
  const question326 = findReplyByQuestionId(replies, 326)
  const question327 = findReplyByQuestionId(replies, 327)
  const question328 = findReplyByQuestionId(replies, 328)
  const question329 = findReplyByQuestionId(replies, 329)
  const question332 = findReplyByQuestionId(replies, 332)
  const question333 = findReplyByQuestionId(replies, 333)
  const question334 = findReplyByQuestionId(replies, 334)
  const question335 = findReplyByQuestionId(replies, 335)
  const question336 = findReplyByQuestionId(replies, 336)
  const question338 = findReplyByQuestionId(replies, 338)
  const question353 = findReplyByQuestionId(replies, 353)
  const question354 = findReplyByQuestionId(replies, 354)
  const question355 = findReplyByQuestionId(replies, 355)

  const currentMonth = new Date(endDate).getMonth()
  const currentYear = new Date(endDate).getFullYear()

  const chunkArray = (arr, size) => {
    const result = []
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size))
    }
    return result
  }

  const renderImages = documents => {
    if (!documents) return null
    const groups = chunkArray(documents, 3)

    return groups.map((group, idx) => (
      <div
        key={idx}
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '16px',
          marginTop: '15px',
          flexWrap: 'wrap'
        }}
      >
        {group.map(doc => (
          <div
            key={doc.src}
            style={{
              textAlign: 'center',
              maxWidth: '220px',
              boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
              overflow: 'hidden',
              backgroundColor: '#fff'
            }}
          >
            <Image
              src={doc.src}
              style={{
                height: '200px',
                width: '100%',
                objectFit: 'cover'
              }}
            />
            {doc?.description && (
              <div
                style={{
                  padding: '8px',
                  fontSize: '12pt',
                  textAlign: 'justify',
                  marginLeft: 0,
                  marginRight: 0,
                  textIndent: '1.25cm',
                  marginTop: 0,
                  marginBottom: '8pt',
                  lineHeight: 1.16,
                  borderTop: '1px solid #eee',
                  background: '#fafafa'
                }}
              >
                {doc.description}
              </div>
            )}
          </div>
        ))}
      </div>
    ))
  }

  const renderQuestion = question => {
    if (!question?.question?.name) return null

    const isArray = Array.isArray(question?.value)
    const displayValue = isArray
      ? ''
      : typeof question?.value === 'boolean'
      ? question.value
        ? 'Sim'
        : 'Não'
      : question?.value ?? 'N/A'

    const files = (isArray ? question?.value : question?.documents) ?? []

    return (
      <section>
        {/* Gap 1 (PR #761 seguimento, pedido da Julia Buzzo): este <p> compartilhado por
            renderQuestion() só tinha recebido o textAlign:'justify' da 1ª rodada de #761 —
            faltava o resto do espaçamento de parágrafo (recuo de 1ª linha, margens,
            line-height) aplicado aos demais parágrafos do documento na 2ª rodada.
            fontFamily não é repetido aqui: herda de 'Arial, sans-serif' do <div> raiz,
            mesmo padrão dos outros parágrafos já corrigidos neste arquivo. */}
        <p
          style={{
            textAlign: 'justify',
            marginLeft: 0,
            marginRight: 0,
            textIndent: '1.25cm',
            marginTop: 0,
            marginBottom: '8pt',
            lineHeight: 1.16
          }}
        >
          <strong>{question?.question?.name}:</strong> {displayValue}
        </p>

        {files.length > 0 && (
          <Grid wrap gap={0.5} align="center" justify="center">
            {renderImages(files)}
          </Grid>
        )}
      </section>
    )
  }

  // Gap 4 (pedido da Julia Buzzo): sem fontWeight:'bold' forçado — o Sumário é uma lista de
  // links com "leaders" de número de página, não corpo de texto corrido, então mantemos
  // peso normal (herdando Arial 12pt do <div> raiz) e SEM o tratamento de justify/recuo de
  // 1ª linha usado no corpo do documento.
  const linkStyle = {
    color: 'black',
    textDecoration: 'none',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '7.5px'
  }

  // Causa raiz do Sumário com números errados (reportado pela Julia Buzzo): o PR #779
  // envolveu cada título de seção (exceto "1. Introdução") com `<View pageBreakBefore>`,
  // que sempre empurra a seção para o topo de uma página nova — mas os números abaixo
  // continuaram cravados nos valores de antes daquele PR, e o conteúdo de cada seção
  // (nº de perguntas respondidas, nº de fotos anexadas, ver `renderQuestion`/
  // `renderImages` acima) varia por Atividade, então nenhum número fixo se mantém certo.
  // `page` não é mais digitado à mão: vem de `useEasySolutionsPageNumbers`
  // (`_shared/pagination.js`), que mede a posição real de cada âncora já renderizada —
  // mesma técnica já usada em `pdfs/bradesco/pgr/_helpers/pagination.js`.
  const summaryItems = [
    { id: 'introducao', title: '1. Introdução' },
    { id: 'servicos', title: '2. Serviços Realizados' },
    { id: 'tensao-central', title: '3. Tensões da Central' },
    { id: 'teste-sistema', title: '4. Teste do Sistema' },
    { id: 'sistema-ao-sair', title: '5. Sistema ao Sair' },
    { id: 'conclusao', title: '6. Conclusão' }
  ]

  // Ordem de documento das âncoras com `pageBreakBefore` (todas, exceto "introducao", que
  // já começa no topo da página por causa do `pageBreakAfter` do Sumário) — necessária
  // para o motor de paginação calcular o deslocamento acumulado corretamente.
  const forcedBreakAnchorIds = ['servicos', 'tensao-central', 'teste-sistema', 'sistema-ao-sair', 'conclusao']
  const pageNumbers = useEasySolutionsPageNumbers(
    summaryItems.map(item => item.id),
    forcedBreakAnchorIds
  )

  return (
    <div
      style={{
        fontFamily: 'Arial, sans-serif',
        fontSize: '12pt',
        textAlign: 'justify',
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: '8pt',
        lineHeight: 1.16
      }}
    >
      {/* Gap 5 (pedido da Julia Buzzo, ver PR): capa isolada em pagina propria com
          <View pageBreakAfter> (mesma convencao de page-break CSS ja usada em
          pdfs/bradesco/pgr, ver components/pdf/View.js / 00.CoverSection.js), em vez de
          depender so da contagem de <br/> para empurrar o conteudo seguinte para a
          proxima pagina. Isso corrige a causa raiz do espaco em branco grande antes do
          "Sumario" relatado pela Julia: com @page { margin: 3cm 2cm 2cm 3cm } (round 3
          de #761) a area util da pagina encolheu, e a contagem antiga de <br/> (calibrada
          para as margens anteriores) passou a sobrar/faltar. Com o page-break explicito,
          o bloco seguinte SEMPRE comeca no topo da proxima pagina, independente da
          contagem de <br/> usada aqui so para espacamento vertical dentro da propria
          pagina -- essa contagem residual foi removida no seguimento abaixo apos causar overflow de pagina. */}
      <View pageBreakAfter>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br /> <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <h2 style={{ textAlign: 'center', fontFamily: 'Arial, sans-serif', fontSize: '16pt' }}>
          SABIC CENTRAL FM-200 <br />
          <br /> MANUTENÇÃO PREVENTIVA <br />
          <br />
          {MONTHS[currentMonth]?.toUpperCase()} - {currentYear} <br />
        </h2>
      {/* Seguimento (2º report da Julia Buzzo, mesmo PR): removida a contagem residual
          de <br/> que ficava aqui como "estimativa conservadora" pos-#761. Combinada
          com o pageBreakAfter, ela empurrava o conteudo alem de uma pagina inteira e
          transbordava para uma pagina extra quase em branco antes da quebra forcada
          entrar em acao -- essa era a causa das paginas em branco no meio do
          documento. O pageBreakAfter sozinho ja garante que o proximo bloco comece
          no topo da proxima pagina; nenhum <br/> de preenchimento e necessario aqui. */}
      </View>
      <View pageBreakAfter>
        <LineSeparator weight={4} color={COLORS.light3} padding={4} />
        <h2>
          Sumário
        </h2>
        <br />
        <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
          {summaryItems.map(item => (
            <li key={item.id}>
              <a href={`#${item.id}`} style={linkStyle}>
                <span>{item.title}</span>
                <span style={{ flex: 1, margin: '0 10px', borderBottom: '2px dotted #000', lineHeight: 0 }} />
                <span>{pageNumbers[item.id] ?? ''}</span>
              </a>

              {item.children?.map(child => (
                <a key={child.id} href={`#${child.id}`} style={linkStyle}>
                  <span style={{ textIndent: '10px' }}>{child.title}</span>
                  <span style={{ flex: 1, margin: '0 10px', borderBottom: '2px dotted #000', lineHeight: 0 }} />
                  <span>{pageNumbers[child.id] ?? ''}</span>
                </a>
              ))}
            </li>
          ))}
        </ul>
        {/* Seguimento (2º report da Julia Buzzo): mesma remocao do bloco de capa acima --
            a contagem residual de <br/> aqui transbordava a pagina do Sumario e, com o
            pageBreakAfter, gerava uma pagina extra quase em branco antes da Introducao.
            O pageBreakAfter ja garante que o proximo bloco comece na pagina certa. */}
      </View>
      {/* Âncora "zero" do motor de paginação do Sumário (ver `_shared/pagination.js`):
          marca o topo do conteúdo do corpo, que sempre começa na página 3 por causa do
          `pageBreakAfter` do Sumário logo acima. */}
      <div id={BODY_ORIGIN_ID} />
      <LineSeparator weight={4} color={COLORS.light3} padding={4} />
      <h3 id="introducao">1. Introdução</h3>
      {/* Gap 3: normalizado de textIndent:'2em' para '1.25cm' + resto do espaçamento de
          parágrafo, igual ao usado no restante do documento. */}
      <p
        style={{
          textAlign: 'justify',
          marginLeft: 0,
          marginRight: 0,
          textIndent: '1.25cm',
          marginTop: 0,
          marginBottom: '8pt',
          lineHeight: 1.16
        }}
      >
        Este Relatório tem como objetivo expressar as atividades realizadas pela empresa Easy Solutions, bem como teste
        nos dispositivos do sistema de combate FM-200, visando informar sempre as melhorias cabíveis ao sistema de
        acordo com a necessidade de cada cliente e atender a NBR 17240-2010 (Sistema de Detecção e Alarme de Incêndio,
        Projetos, Instalações e Manutenções do Sistema).
      </p>
      <View pageBreakBefore>
        <h3 id="servicos">2. Serviços Realizados</h3>
      </View>
      {renderQuestion(question302)}
      {renderQuestion(question303)}
      {renderQuestion(question304)}
      {renderQuestion(question311)}
      {renderQuestion(question312)}
      <View pageBreakBefore>
        <h3 id="tensao-central">3. Tensões da central</h3>
      </View>
      {question342?.question?.name && (
        <section>
          <p>
            <strong>{question342?.question?.name}:</strong>{' '}
            {Array.isArray(question342?.value)
              ? ''
              : (
                  <p
                    style={{
                      textAlign: 'justify',
                      marginLeft: 0,
                      marginRight: 0,
                      textIndent: '1.25cm',
                      marginTop: 0,
                      marginBottom: '8pt',
                      lineHeight: 1.16
                    }}
                  >
                    {question342?.value?.split('\n').map((line, idx) => (
                      <React.Fragment key={idx}>
                        {line}
                        <br />
                      </React.Fragment>
                    )) || 'N/A'}
                  </p>
                ) || 'N/A'}
          </p>
        </section>
      )}
      <View pageBreakBefore>
        <h3 id="teste-sistema">4. Teste do Sistema</h3>
      </View>
      {renderQuestion(question315)}
      {renderQuestion(question316)}
      {renderQuestion(question318)}
      {renderQuestion(question319)}
      {renderQuestion(question320)}
      {renderQuestion(question321)}
      {renderQuestion(question322)}
      {renderQuestion(question323)}
      {renderQuestion(question326)}
      {renderQuestion(question327)}
      {renderQuestion(question328)}
      {renderQuestion(question329)}
      {renderQuestion(question332)}
      {renderQuestion(question333)}
      {renderQuestion(question334)}
      {renderQuestion(question335)}
      {renderQuestion(question336)}
      {renderQuestion(question338)}
      <View pageBreakBefore>
        <h3 id="sistema-ao-sair">5. Sistema ao sair</h3>
      </View>
      {renderQuestion(question353)}
      {renderQuestion(question354)}
      <View pageBreakBefore>
        <h3 id="conclusao">6. Conclusão</h3>
      </View>
      {renderQuestion(question355)}
      <Separator weight={5} />
    </div>
  )
}

export default Content
